var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSortingAsc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.869611 6H9.15086C9.90086 6 10.3071 5.09375 9.74461 4.53125L5.61961 0.28125C5.46336 0.09375 5.24461 0 5.02586 0C4.80711 0 4.55711 0.09375 4.40086 0.28125L0.275861 4.53125C-0.286639 5.09375 0.119611 6 0.869611 6Z",
    fill: "#4A4E57"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74461 9.5L5.61961 13.75C5.46336 13.9375 5.24461 14 5.02586 14C4.77586 14 4.55711 13.9375 4.40086 13.75L0.275861 9.5C-0.286639 8.9375 0.119611 8 0.869611 8H9.15086C9.90086 8 10.3071 8.9375 9.74461 9.5Z",
    fill: "#9FA1A7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortingAsc);
export default __webpack_public_path__ + "static/media/sorting-asc.0cefc982.svg";
export { ForwardRef as ReactComponent };